import {GoTheme} from '@yandex-taxi/go-web-components'

export const commonStyles = (theme: GoTheme) => ({
  root: {
    display: 'inline-block',
  },
  timeInput: {
    width: 60,
    marginLeft: 8,
  },
  calendarIcon: {
    marginTop: -1,
  },
  paper: {
    ...theme.mixins.paper,
    padding: 16,
    paddingBottom: 12,
    display: 'inline-block',
    margin: '4px 0px',
  },
})
